export const PCM_CUSTOM_POI_MAX_ROWS = 1500;
